import { type ReactNode, useLayoutEffect, useState } from "react";

export const STAGE_W = 1280;
export const STAGE_H = 720;

/**
 * Lays out children on a fixed 1280×720 stage and fits it to the window, letterboxed. It uses CSS zoom, not
 * transform: scale(): a scaled layer is rasterised at 1280×720 and stretched, so text went soft, and sharpened
 * again or not whenever something on the slide animated. Zoom lays the stage out at the real size instead.
 */
export function ScaledStage({ children }: { children: ReactNode }) {
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const fit = () => setScale(Math.min(window.innerWidth / STAGE_W, window.innerHeight / STAGE_H));
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        overflow: "hidden",
        background: "var(--ground)",
        display: "grid",
        placeItems: "center",
      }}
    >
      <div
        data-stage
        style={{
          position: "relative",
          width: STAGE_W,
          height: STAGE_H,
          zoom: scale,
          overflow: "hidden",
          background: "var(--ground)",
        }}
      >
        {children}
      </div>
    </div>
  );
}
